/* eslint-disable no-param-reassign */
/** Forget the prefetched lecture data and token. */
const prefetchClear = (state) => {
  state.prefetchSgf = '';
  state.prefetchJson = [];
  state.prefetchLessonId = 0;
  state.lectureToken = '';
};

/** Store prefetched data for lessonId. Data from another lesson is dropped first, so the token always belongs to prefetchLessonId. */
const prefetchSet = (state, { sgf, json, lectureToken, lessonId }) => {
  if (state.prefetchLessonId !== lessonId) prefetchClear(state);
  if (sgf && sgf.length) state.prefetchSgf = sgf;
  if (json && json.length) state.prefetchJson = json;
  if (lectureToken && lectureToken.length) state.lectureToken = lectureToken;
  state.prefetchLessonId = lessonId;
};

module.exports = { prefetchClear, prefetchSet };
